<template>
  <div class="layout-center-wrap">
    <!-- 상단 타이틀 -->
    <section class="top_head">
      <div class="page-tit__wrap">
        <h1 class="page-tit__sub">Vulnerability Report</h1>
        <p class="page-tit">Vulnerability Report application</p>
      </div>
    </section>
    <!-- 탭 메뉴 -->
    <Tabs
      :tabs="[
        'Personal Information',
        'Confirmation points',
        'Vulnerability Information',
      ]"
      v-model="selectedTab"
      role="tablist"
    />

    <!-- 탭 내용 -->
    <component
      v-model="totalInfo"
      serviceType="report"
      :is="currentTabComponent"
      :edit="true"
      @changeTab="changeTab"
    />
    <div class="btn__wrap type-bottom-board">
      <button
        v-if="['VulInfo'].includes(currentTabComponent.name)"
        type="button"
        class="btn btn--l btn--darker_blue"
        @click="submitReport"
      >
        Submit
      </button>
    </div>
  </div>
</template>

<script>
import { computed, ref, nextTick, onMounted, inject } from "vue";
import { useRoute, useRouter } from "vue-router";
import { useStore } from "vuex";
import Tabs from "@/component/Tabs.vue";
import gt from "@/component/GetTokenValue.js";
import VulEval from "@/views/eval/CvssEval.vue";
import PersonalInfo from "@/views/report/submission/ForeignUserTab/PersonalInfoTab.vue";
import CheckList from "@/views/report/submission/ForeignUserTab/CheckListTab.vue";
import VulInfo from "@/views/report/submission/ForeignUserTab/VulInfoTab.vue";
import reportHandler from "@/views/report/ReportHandler";

export default {
  components: { PersonalInfo, CheckList, VulInfo, VulEval, Tabs },
  setup() {
    const axios = inject("axios");
    const lodash = inject("lodash");
    const route = useRoute();
    const router = useRouter();
    const store = useStore();

    const showLoading = () => store.dispatch("loading/show");
    const hideLoading = () => store.dispatch("loading/hide");

    // data 정의
    const totalInfo = ref(reportHandler.getTotalInfo());
    const memberType = ref("foreigner");
    // 탭 인덱스 관리
    const selectedTab = ref(0);

    // methods 정의
    const submitReport = async () => {
      totalInfo.value.personal.userEngName = totalInfo.value.personal.userName;
      //외국인 신고는 신고포상제를 일반신고로 지정
      totalInfo.value.reportInfo.rewardNm = "64224bef33b623536e9769ca";
      totalInfo.value.reportInfo.rewardSubNm = "64224bef33b623536e9769cb";

      showLoading();
      reportHandler
        .submitReport(lodash.cloneDeep(totalInfo.value), memberType.value)
        .then((res) => {
          hideLoading();
          if (res) {
            router.go(0);
          }
        });
    };

    const changeTab = async (nextIndex) => {
      selectedTab.value = nextIndex;
      await nextTick();
      window.scrollTo({ top: 200, left: 0, behavior: "smooth" });
    };

    // computed 정의
    // 탭 컴포넌트 매핑
    const tabComponents = computed(() => [
      PersonalInfo,
      CheckList,
      VulInfo,
      VulEval,
    ]);
    const currentTabComponent = computed(
      () => tabComponents.value[selectedTab.value]
    );

    // life cycle 정의
    onMounted(() => {
      const role = gt.getRole();
      const guestType = gt.getGuestType();

      if (!route.meta.role.includes(role)) {
        axios.setErrorSession(403);
      }

      if (role === "NONMEMBER" && route.meta.guestType !== guestType) {
        axios.setErrorSession(403);
      }
    });

    // html에서 사용될 데이터 정의
    return {
      selectedTab,
      currentTabComponent,
      changeTab,
      totalInfo,
      submitReport,
    };
  },
};
</script>

<style>
</style>